import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import './infoFamilyPopup.scss';
const InfoFamilyPackagePopup = (props) => {
  function getPackageDataString() {
    const titleFromEpi = props.abroadPackageClient?.titleEpi;
    const packageContainsData =
      props.abroadPackageClient && Array.isArray(props.abroadPackageClient.packageDetailsList)
        ? props.abroadPackageClient.packageDetailsList[0]
        : '';
    const sms = packageContainsData?.sms.unit ? `${packageContainsData.sms.value} SMS` : '';
    const voice = packageContainsData?.voice.unit ? `${packageContainsData.voice.value} שיחות` : '';
    const data = packageContainsData?.data.unit ? `${packageContainsData.data.value + packageContainsData.data.unit}` : '';
    const price = props.abroadPackageClient?.price;
    return `${titleFromEpi} ${data ?? ',' + data} ${voice ?? ',' + voice} ${sms ?? ',' + sms} ${'ב-' + '₪' + price}`;
  }
  return (
    <div className='InfoFamilyPackagePopup'>
      <Container>
        <Row className='firstTitle'>
          <Col>מידע על הטבת בני משפחה</Col>
        </Row>
        <Row className='secondTitle'>
          <Col>{getPackageDataString()}</Col>
        </Row>
        {props.instructionFamilyMemberPackage?.value && (
          <Row className='content'>
            <ul>
              {props.instructionFamilyMemberPackage?.value?.map((item, index) => {
                return <li key={index}>{item}</li>;
              })}
            </ul>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default InfoFamilyPackagePopup;
